function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import { Skeleton, message, Descriptions, Button, Divider, Tag, Tabs, Modal, Alert, Select, Form, Upload, List, Typography } from 'antd';
import Common from "./includes/Common";
import { Container, Row, Col } from 'react-bootstrap';
import { GenderMale, GenderFemale, CardChecklist, HospitalFill, ExclamationCircleFill, Upload as UploadIc } from 'react-bootstrap-icons';
import AddPatientItem from "./forms/AddPatientItem";
import Receipt from "./Receipt";
import Moment from "react-moment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var PatientView = function PatientView(_ref) {
  var pid = _ref.pid;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    patient = _useState2[0],
    setPatient = _useState2[1];
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFormLoading = _useState6[0],
    setIsFormLoading = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    orderedItems = _useState8[0],
    setOrderedItems = _useState8[1];
  var _useState9 = useState([]),
    _useState10 = _slicedToArray(_useState9, 2),
    orderedOptions = _useState10[0],
    setOrderedOptions = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    companies = _useState12[0],
    setCompanies = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    serviceTree = _useState14[0],
    setServiceTree = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isPdaActive = _useState16[0],
    setIsPdaActive = _useState16[1];
  var _useState17 = useState(""),
    _useState18 = _slicedToArray(_useState17, 2),
    successMessage = _useState18[0],
    setSuccessMessage = _useState18[1];
  var _useState19 = useState(""),
    _useState20 = _slicedToArray(_useState19, 2),
    errorMessage = _useState20[0],
    setErrorMessage = _useState20[1];
  var _useState21 = useState(true),
    _useState22 = _slicedToArray(_useState21, 2),
    dataChanged = _useState22[0],
    setDataChanged = _useState22[1];
  var _useState23 = useState([]),
    _useState24 = _slicedToArray(_useState23, 2),
    selectedItems = _useState24[0],
    setSelectedItems = _useState24[1];
  var _useState25 = useState([]),
    _useState26 = _slicedToArray(_useState25, 2),
    file = _useState26[0],
    setFile = _useState26[1];
  var _useState27 = useState(true),
    _useState28 = _slicedToArray(_useState27, 2),
    companyDisabled = _useState28[0],
    setCompanyDisabled = _useState28[1];
  var _useState29 = useState(null),
    _useState30 = _slicedToArray(_useState29, 2),
    userCompany = _useState30[0],
    setUserCompany = _useState30[1];
  var _useState31 = useState(true),
    _useState32 = _slicedToArray(_useState31, 2),
    uploadDisabled = _useState32[0],
    setUploadDisabled = _useState32[1];
  var _useState33 = useState(0),
    _useState34 = _slicedToArray(_useState33, 2),
    receipAmount = _useState34[0],
    setReceipAmount = _useState34[1];
  var _useState35 = useState([]),
    _useState36 = _slicedToArray(_useState35, 2),
    rdata = _useState36[0],
    setRdata = _useState36[1];
  var _useState37 = useState([]),
    _useState38 = _slicedToArray(_useState37, 2),
    companyOptions = _useState38[0],
    setCompanyOptions = _useState38[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  function printR() {
    var content = document.getElementById("prtdiv");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  }
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    }
  };
  var handleOptChange = function handleOptChange(v) {
    setSelectedItems(v);
  };
  var categoryOptions = [{
    label: 'Particulier',
    value: 0
  }, {
    label: 'Conventionné',
    value: 1
  }];
  var onCategorieChanged = function onCategorieChanged(e) {
    if (e == 1) {
      setCompanyDisabled(false);
      form.setFieldsValue(patient.company.id);
      setUploadDisabled(false);
    } else {
      setUploadDisabled(true);
      setCompanyDisabled(true);
    }
  };
  var onCompanyChanged = function onCompanyChanged(v) {
    setUserCompany(companies.filter(function (c) {
      return c.id == v;
    })[0]);
  };
  var handleCommand = function handleCommand(values) {
    setErrorMessage("");
    setSuccessMessage("");
    var formData = new FormData();
    formData.append('category', patient.category);
    formData.append('company_id', patient.company_id);
    formData.append("uid", Common.currentUser.id);
    formData.append("pid", patient.id.toString());
    formData.append("file", file);
    alert('handling command');
    var ta = 0;
    var oo = Array();
    var deptArray = Array();
    var prescriptionsIds = Array();
    setRdata([]);
    orderedItems.forEach(function (e) {
      if (selectedItems.includes(e.medical_item.id)) {
        //IF CASH PATIENT THE USE BASE PRICE 
        if (values.category == 0) {
          ta += e.base_price;
          setRdata(function (prev) {
            return [].concat(_toConsumableArray(prev), [e.label + " - " + e.base_price.toLocaleString('fr') + " GNF"]);
          });
        } else {
          //HANDLING COMPANY PRICE CATEGORIES
          var comp = companies.filter(function (c) {
            return c.id == values.company_id;
          })[0];
          setUserCompany(comp);
          if (comp.company_id == null) {
            ta += e.ent_price;
            setRdata(function (prev) {
              return [].concat(_toConsumableArray(prev), [e.label + " - " + e.ent_price.toLocaleString('fr') + " GNF"]);
            });
          }
          if (comp.company_id != null && comp.company.type == 1) {
            ta += e.ins_price;
            setRdata(function (prev) {
              return [].concat(_toConsumableArray(prev), [e.label + " - " + e.ins_price.toLocaleString('fr') + " GNF"]);
            });
          }
          if (comp.company_id != null && comp.company.type == 2) {
            ta += e.lan_price;
            setRdata(function (prev) {
              return [].concat(_toConsumableArray(prev), [e.label + " - " + e.lan_price.toLocaleString('fr') + " GNF"]);
            });
          }
        }
        oo.push(e.medical_item.id);
        deptArray.push(e.medical_item.department_id);
        prescriptionsIds.push(e.id);
      }
    });
    formData.append("ordered_items", oo);
    formData.append("departments_id", deptArray.toString());

    //setOrderedOptions(oo); 
    formData.append('amount', ta);
    if (values.category == 1) {
      if (companies.filter(function (c) {
        return c.id == values.company_id;
      }).length > 0) {
        var company_rate = companies.filter(function (c) {
          return c.id == values.company_id;
        })[0].rate;
        setUserCompany(companies.filter(function (c) {
          return c.id == values.company_id;
        })[0]);
        formData.append('company_part', ta * company_rate * 0.01);
        formData.append('patient_part', ta * (100 - company_rate) * 0.01);
        setReceipAmount(ta * (100 - company_rate) * 0.01);
      }
    } else {
      formData.append("patient_part", ta);
      formData.append("company_part", 0);
      setReceipAmount(ta);
    }
    formData.append('prescriptions_ids', prescriptionsIds.toString());
    confirm({
      title: 'Confirmez-vous ?',
      icon: /*#__PURE__*/_jsx(ExclamationCircleFill, {}),
      content: /*#__PURE__*/_jsx(Receipt, {
        company: userCompany,
        options: oo.toString(),
        serviceTree: serviceTree
      }),
      onOk: function onOk() {
        var _iterator = _createForOfIteratorHelper(formData.entries()),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var pair = _step.value;
            console.log(pair[0] + ' - ' + pair[1]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        execOrder(formData);
      },
      onCancel: function onCancel() {
        console.log('Cancel');
      }
    });
  };
  var execOrder = function execOrder(formData) {
    setIsFormLoading(true);
    axios.post(Common.baseApiUrl + 'executepatientorder', formData).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        setDataChanged(true);
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        printR();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage('Une erreur est survenue');
    })["finally"](function () {
      setIsFormLoading(false);
    });
  };
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.all([axios.get(Common.baseApiUrl + "getcustomerbyid/" + pid.toString() + "/" + Common.currentUser.id), axios.get(Common.baseApiUrl + "getcustomerprescriptions/" + pid.toString() + "/" + Common.currentUser.id), axios.get(Common.baseApiUrl + "getcompanylist"), axios.get(Common.baseApiUrl + "getservicetree")]).then(function (response) {
      if (response[0].data.status == 200) {
        setPatient(response[0].data.patient);
      } else {
        message.error({
          content: response[0].data.message,
          delay: 4
        });
      }
      if (response[1].data.status == 200) {
        setOrderedOptions([]);
        setOrderedItems(response[1].data.prescriptions.filter(function (p) {
          return p.medical_item.department.dcode != "LUN" && p.medical_item.department.dcode != "PHA";
        }));
        var ar = new Array();
        response[1].data.prescriptions.filter(function (p) {
          return p.medical_item.department.dcode != "LUN" && p.medical_item.department.dcode != "PHA";
        }).forEach(function (p) {
          setOrderedOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: p.medical_item.label,
              value: p.medical_item.id
            }]);
          });
          ar.push(p.medical_item.id);
          setSelectedItems(ar);
        });
        form.setFieldsValue({
          items: ar
        });
      }
      if (response[2].data.status == 200) {
        setCompanyOptions([]);
        setCompanies(response[2].data.companyList);
        response[2].data.companyList.forEach(function (c) {
          if (c.company_id == null) setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.label,
              value: c.id
            }]);
          });else setCompanyOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              label: c.company == null ? "" : c.company.label + "-" + c.label,
              value: c.id
            }]);
          });
        });
      }
      if (response[3].data.status == 200) {
        setServiceTree(response[3].data.services);
      }
      form.setFieldsValue({
        category: 0
      });
    })["catch"](function (error) {
      message.error({
        content: error.toString(),
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [pid, dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("br", {}), patient != null && /*#__PURE__*/_jsxs("div", {
      style: {
        textAlign: 'center'
      },
      id: "prtdiv",
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: '70px',
          textAlign: 'center !important'
        },
        children: /*#__PURE__*/_jsx("img", {
          src: "drawables/logo_sos.jpeg",
          style: {
            width: '100%'
          }
        })
      }), "Date : ", /*#__PURE__*/_jsx(Moment, {
        format: "DD/MM/YYYY H:m"
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h2", {
        children: ["CODE PATIENT : ", patient.idnumber]
      }), /*#__PURE__*/_jsxs("h5", {
        children: ["Nom : ", patient.firstname + " " + patient.lastname]
      }), /*#__PURE__*/_jsx(List, {
        header: /*#__PURE__*/_jsx("div", {
          children: "Actes / Produit(s)"
        }),
        footer: /*#__PURE__*/_jsx("b", {
          children: "TOTAL (GNF) " + receipAmount.toLocaleString('fr')
        }),
        bordered: true,
        dataSource: rdata,
        renderItem: function renderItem(item) {
          return /*#__PURE__*/_jsx(List.Item, {
            children: /*#__PURE__*/_jsx(Typography.Text, {
              mark: true,
              children: item
            })
          });
        }
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), userCompany != null && /*#__PURE__*/_jsx(Alert, {
        type: "warning",
        banner: true,
        message: "Prise en charge de " + userCompany.rate.toString() + "% par " + userCompany.label
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx("b", {
          children: "Adresse: Conakry, Kaloum, Manquepa - Tel: 622 32 59 32"
        })
      })]
    }), /*#__PURE__*/_jsx("iframe", {
      id: "ifmcontentstoprint",
      style: {
        height: '0px',
        width: '0px',
        position: 'absolute'
      }
    }), isDataLoading && /*#__PURE__*/_jsx(Skeleton, {
      active: true
    }), patient != null && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsxs(Col, {
            lg: 1,
            md: 1,
            sm: 1,
            xs: 1,
            children: [patient.gender == 'F' && /*#__PURE__*/_jsx(GenderFemale, {
              size: 35
            }), patient.gender == 'H' && /*#__PURE__*/_jsx(GenderMale, {
              size: 35
            })]
          }), /*#__PURE__*/_jsxs(Col, {
            lg: 4,
            md: 4,
            sm: 5,
            children: [/*#__PURE__*/_jsx("div", {
              className: "cool-radius user-personal-info",
              children: /*#__PURE__*/_jsxs(Descriptions, {
                column: 2,
                title: "Informations personelles",
                children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                  labelStyle: {
                    fontWeight: 'Bold'
                  },
                  span: 2,
                  contentStyle: {
                    fontWeight: 'Bold'
                  },
                  label: "ID PATIENT",
                  children: patient.idnumber
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Pr\xE9nom",
                  children: patient.firstname
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Nom",
                  children: patient.lastname
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Tel.",
                  children: patient.mobile
                }), /*#__PURE__*/_jsx(Descriptions.Item, {
                  label: "Genre",
                  children: patient.gender
                })]
              })
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: null,
              icon: /*#__PURE__*/_jsx(HospitalFill, {
                size: 26
              }),
              size: "middle",
              children: "Hospitaliser"
            })]
          }), /*#__PURE__*/_jsx(Col, {
            lg: 7,
            md: 7,
            sm: 6,
            children: /*#__PURE__*/_jsxs(Tabs, {
              children: [/*#__PURE__*/_jsx(Tabs.TabPane, {
                tab: /*#__PURE__*/_jsx("b", {
                  children: "ORIENTATION PATIENT"
                }),
                children: /*#__PURE__*/_jsx(AddPatientItem, {
                  patient: patient
                })
              }, 1), /*#__PURE__*/_jsxs(Tabs.TabPane, {
                tab: /*#__PURE__*/_jsx("b", {
                  children: "PRESCRIPTION MEDECIN"
                }),
                children: [isDataLoading == false && orderedItems.length == 0 ? /*#__PURE__*/_jsx("div", {
                  style: {
                    textAlign: "center"
                  },
                  children: "Aucune"
                }) : /*#__PURE__*/_jsx("div", {}), patient != null && /*#__PURE__*/_jsxs(Form, {
                  form: form,
                  onFinish: handleCommand,
                  children: [/*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 6,
                      md: 6,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "items",
                        rules: [{
                          required: true,
                          message: "Champ obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Select, {
                          onChange: handleOptChange,
                          mode: "multiple",
                          optionLabelProp: "label",
                          options: orderedOptions
                        })
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 6,
                      md: 6,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "category",
                        label: "Cat\xE9gorie",
                        rules: [{
                          required: true,
                          message: 'Choisir la catégorie'
                        }],
                        children: /*#__PURE__*/_jsx(Select, {
                          showSearch: true,
                          onChange: onCategorieChanged,
                          optionLabelProp: "label",
                          defaultValue: [0],
                          optionFilterProp: "label",
                          filterOption: function filterOption(input, option) {
                            return option.label.toLowerCase().includes(input.toLowerCase());
                          },
                          options: categoryOptions
                        })
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 6,
                      md: 6,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "company_id",
                        label: "Prise en charge",
                        children: /*#__PURE__*/_jsx(Select, {
                          onChange: onCompanyChanged,
                          disabled: companyDisabled,
                          showSearch: true,
                          options: companyOptions
                        })
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 6,
                      md: 6,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        label: "Bon de prise en charge",
                        children: /*#__PURE__*/_jsx(Upload, _objectSpread(_objectSpread({}, props), {}, {
                          children: /*#__PURE__*/_jsx(Button, {
                            disabled: uploadDisabled,
                            icon: /*#__PURE__*/_jsx(UploadIc, {
                              size: 20
                            }),
                            children: /*#__PURE__*/_jsx("b", {
                              children: "Charger le bon"
                            })
                          })
                        }))
                      })
                    })]
                  }), /*#__PURE__*/_jsx(Form.Item, {
                    children: /*#__PURE__*/_jsx(Button, {
                      htmlType: "submit",
                      type: "primary",
                      disabled: orderedOptions.length == 0,
                      children: "Valider la commande"
                    })
                  })]
                }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), successMessage && /*#__PURE__*/_jsx(Alert, {
                  type: "success",
                  message: successMessage,
                  banner: true
                }), errorMessage && /*#__PURE__*/_jsx(Alert, {
                  type: "error",
                  message: errorMessage,
                  banner: true
                })]
              }, 2)]
            })
          })]
        })
      })
    })]
  });
};
export default PatientView;